module.exports = __webpack_public_path__ + "9f7dcc9907e9b3dfd576bd22dfd930fe.png";